<template>
  <div class="px-1 mt-0 pt-0" style="height: 60vh">
    <button
      :disabled="$store.state.isonlyread"
      v-show="datos.length > 0"
      class="btn btn-sm btn-link"
      @click="tableToExcel('table', 'Lorem Table')">
      <span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL.
    </button>

    <p class="my-0 text-center">{{ msg }}</p>

    <div class="table-responsive xtablefixed" style="height: 71vh">
      <table class="table-hover" ref="table">
        <thead class="text-center green darken-4">
          <tr class="white--text">
            <th class="text-center" rowspan="3">Programas</th>
            <th :colspan="100">Recaudado</th>
          </tr>
          <tr class="white--text">
            <th v-for="(hc, ind) in headers" :key="ind" :colspan="hc.pagos.length" class="">
              {{ hc.nombre }}
            </th>
            <th rowspan="2">Total</th>
          </tr>
          <tr class="white--text">
            <template v-for="hc in headers">
              <th v-for="hp in hc.pagos" :key="hp.rowkey" class="">{{ hp.title }}</th>
            </template>
          </tr>
        </thead>

        <tbody class="text-right">
          <tr class="" v-for="(d, ind) in datos" :key="ind">
            <td class="text-left">
              <b>{{ ind + 1 }}.- </b> {{ d.estudiante.nombre }}
            </td>
            <template v-for="r in d.recaudaciones">
              <td v-for="p in r.pagos" :key="p.rowkey + ind">{{ parsecomas(p.monto) }}</td>
            </template>
            <td class="text-right">{{ parsecomas(d.xtotal_row) }}</td>
          </tr>
          <tr class="text-right green darken-4">
            <td style="background: #196391; color: white" class="text-right">TOTAL</td>
            <td v-for="(t, ind2) in totales" :key="ind2" style="color: white !important">{{ parsecomas(t.monto) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <hr />
  </div>
</template>

<style lang="css">
  @import url('stilo/recaudaciones.css');
</style>

<script>
  import xaxios from '@/xaxios';
  import { stand } from './jsrecaudaciones/standarizarjson.js';
  export default {
    data() {
      return {
        // EXCEL
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        },
        // END EXCEL
        sedes: [],
        datos: [],
        totales: [],
        msg: '',

        headers: [],
      };
    },
    watch: {},
    components: {},
    methods: {
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table;
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
        var link = document.createElement('a');
        link.download = 'REPORTE_RECAUDACION_CORPO.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      reset() {
        this.datos = [];
        this.headers = [];
        this.totales = [];
        this.msg = '';
      },
      obtenerasignaciones(mes, anio, programa, omit_filtro) {
        const vue = this;
        this.datos = [];
        this.headers = [];
        this.totales = [];
        this.msg = '';
        let idp = programa.id;
        if (omit_filtro) idp = 0;
        window.console.log('omit_filtro', omit_filtro);
        // let urla = `${process.env.VUE_APP_API_REST}/api/v2/recaudacion/coorporacion?month=${mes}&year=${anio}&universidad_id=${convenio}`;
        let urla = `${process.env.VUE_APP_API_REST}/api/v2/recaudacion/programa?month=${mes}&year=${anio}&programa_id=${idp}`;
        const promise1 = xaxios.get(urla);
        Promise.all([promise1])
          .then(function (values) {
            if (!values[0] || !values[0].data) values[0] = { data: { data: [] } };
            let data1 = values[0].data.data;
            if (data1.length == 0) vue.msg = 'sin datos para los parametros proporcionados';

            const myjson = stand(data1);
            vue.headers = myjson.headers;
            vue.datos = myjson.data;
            vue.totales = myjson.totales;

            vue.$emit('dataloaded');
          })
          .catch((e) => {
            window.console.error(e);
            vue.msg = e;
            vue.$emit('dataloaded');
          });
      },
      parsecomas(str) {
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
    },
    mounted() {},
  };
  ('');
</script>
